import React$1 from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import SpecialHeadline$1 from '../SpecialHeadline/SpecialHeadline.js';
import StyledTextTeasers from './TextTeasers.style.js';

const TextTeasers = ({
  className,
  headline,
  teasers
}) => /*#__PURE__*/React$1.createElement(StyledTextTeasers, {
  className: className
}, headline && /*#__PURE__*/React$1.createElement("div", {
  className: "textTeasers__headline"
}, /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
  as: "h2",
  variant: "intro",
  text: headline
})), teasers.map(({
  headline: title,
  copy,
  cta,
  link
}) => /*#__PURE__*/React$1.createElement("div", {
  key: title,
  className: "textTeasers__teaser"
}, /*#__PURE__*/React$1.createElement(Link$1, _extends({
  className: "textTeasers__link"
}, link), /*#__PURE__*/React$1.createElement(Typography$1, {
  as: "h3",
  variant: "subheadline"
}, title), /*#__PURE__*/React$1.createElement(Typography$1, null, copy), cta && /*#__PURE__*/React$1.createElement("div", {
  className: "textTeasers__cta"
}, /*#__PURE__*/React$1.createElement("span", null, cta))))));

TextTeasers.propTypes = {
  className: PropTypes$1.string,
  headline: PropTypes$1.string,
  teasers: PropTypes$1.arrayOf(PropTypes$1.shape({
    headline: PropTypes$1.string,
    copy: PropTypes$1.string,
    cta: PropTypes$1.string,
    link: PropTypes$1.shape()
  })).isRequired
};
TextTeasers.defaultProps = {
  className: '',
  headline: ''
};

export default TextTeasers;
